import type { Chain } from '../../../chain';
import { normalizeAddress } from '../normalizeAddress';

export const isSameAddress = (left: string, right: string, chain: Chain) =>
  normalizeAddress(left, chain) === normalizeAddress(right, chain);
